
type ExpenseMap = string[]

// these fields are broken up for each family member
const personalExpenseFieldNames: ExpenseMap = ['clothing', 'grooming', 'medical']

export {
  ExpenseMap,

  personalExpenseFieldNames
}



// WEBPACK FOOTER //
// ./src/app/calcs/expenses/interfaces/index.ts